import { Service } from '@roc/feature-app-core';

const url = {
  LIST_AGREEMENTS: '/api/v1/user/agreement/list',
  DOWNLOAD_AGREEMENT_BY_ID: '/api/v1/user/agreement/download/:id',
};

export class UserAgreementService extends Service {
  listAgreements() {
    return this.get(url.LIST_AGREEMENTS);
  }

  downloadAgreementById(id: number) {
    return this.get(url.DOWNLOAD_AGREEMENT_BY_ID.replace(':id', String(id)), {}, { responseType: 'blob' });
  }
}
